<script>
import {batchWriteOffNext} from "@/api/double/bill_hq";

export default {
  name: "writeOffOptimization",
  props: {
    params: {
      type: Object,
      required: true,
    },
    close: {
      type: Function,
      required: true,
    }
  },
  methods: {
    startCharge() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          // 准备提交 重新拼装需要的数据
          let payload = {
            ...this.form,
            recordId: this.params.recordId,
            collectValue: this.params.collect.amount,
            currency: this.params.collect.currency,
            chargeTime: Math.floor(new Date(this.form.chargeTime).getTime() / 1000),
          }
          // 前端先检查是否金额足够
          if (this.form.channel === 'online') {
            // 先检查币种
            let expectCurrency = this.params.collect.currency;
            if (expectCurrency !== 'CNY' && expectCurrency !== 'USD') {
              return this.$Message.warning(`线上支付仅支持CNY和USD货币，当前期望的币种是 ${expectCurrency}`)
            }
            // 检查余额
            let balance = parseFloat(this.params.customer.balance[expectCurrency]);
            if (parseFloat(payload.collectValue) > balance) {
              return this.$Message.warning(`线上核销时客户余额不足，需要核销金额为 ${payload.collectValue} ${expectCurrency}，客户余额为 ${balance} ${expectCurrency}`)
            }
          }
          // 加载一个全屏的loading
          this.$Spin.show()
          // 提交请求
          batchWriteOffNext(payload).then(res => {
            this.$Spin.hide()
            if (res.data.code) {
              // 发生错误
              this.$Message.error({
                content: res.data.msg,
                duration: 10
              })
            } else {
              this.$Message.success({
                content: res.data.msg,
                duration: 5,
                onClose: () => {
                  this.close()
                }
              })
            }
          }).catch(err => {
            this.$Spin.hide()
          })
        } else {
          console.error('发生未通过验证的错误')
        }
      })
    }
  },
  data() {
    return {
      form: {
        channel: 'online',
        taxTitle: 2,
        bank: 0,
        invoice: 'NO',
        bankRecordId: '',
        remarks: '',
        chargeTime: 0,
      },
      formRules: {
        channel: [
          {required: true, message: '核销渠道不能为空', trigger: 'blur'},
        ],
        taxTitle: [
          {required: true, message: '优选合同抬头不能为空', trigger: 'blur', type: 'number'},
        ],
        bank: [{
          validator: (rule, value, callback) => {
            if (this.form.channel === 'offline' && !value) {
              callback(new Error('线下核销的时候打款银行不能为空'));
            } else {
              callback();
            }
          }
        }],
        bankRecordId: [{
          validator: (rule, value, callback) => {
            if (this.form.channel === 'offline' && !value) {
              callback(new Error('线下核销的时候打款银行交易流水不能为空'));
            } else {
              callback();
            }
          }
        }],
        chargeTime: [{
          validator: (rule, value, callback) => {
            if (this.form.channel === 'offline' && !value) {
              callback(new Error('线下核销的时候交易时间不能为空'));
            } else {
              callback();
            }
          }
        }]
      },
      isFitCustomer:
        this.params.customer.isFit === 1 ? '是' : '否',
      displayCols:
        [
          {
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title: '订单号码',
            width: 140,
            key: 'shipmentNumber',
            align: 'center'
          },
          {
            title: '待核销金额',
            key: 'amountValue',
            align: 'right'
          }
        ],
      dateOption: {
        disabledDate (date) {
          return date && date.valueOf() > Date.now();
        }
      }
    }
  }
}
</script>

<template>
  <!-- 分为左右两栏 -->
  <Form :rules="formRules" ref="form" :model="form">
    <Row :gutter="12">
      <Col span="7">
        <Card :padding="8">
          <div slot="title">客户信息</div>
          <Row :gutter="6">
            <Col :span="24">
              <FormItem label="客户账号">
                <Input v-model="params.customer.account" disabled/>
              </FormItem>
            </Col>
            <div style="height: 2px; border-top: 1px solid #cccccc; width: 100%;"></div>
            <Col :span="12">
              <FormItem label="人民币余额">
                <Input v-model="params.customer.balance.CNY" disabled/>
              </FormItem>
            </Col>
            <Col :span="12">
              <FormItem label="美元余额">
                <Input v-model="params.customer.balance.USD" disabled/>
              </FormItem>
            </Col>
            <div style="height: 2px; border-top: 1px solid #cccccc; width: 100%;"></div>
            <Col :span="17">
              <FormItem label="所属公司">
                <Input v-model="params.customer.ownership" disabled/>
              </FormItem>
            </Col>
            <Col :span="7">
              <FormItem label="散客状态">
                <Input v-model="isFitCustomer" disabled/>
              </FormItem>
            </Col>
          </Row>
        </Card>
        <div style="height: 4px; width: 100%;"></div>
        <Card :padding="8">
          <div slot="title">销售信息</div>
          <Row :gutter="6">
            <Col :span="12">
              <FormItem label="账号">
                <Input v-model="params.customer.salesman.account" disabled/>
              </FormItem>
            </Col>
            <Col :span="12">
              <FormItem label="实名">
                <Input v-model="params.customer.salesman.realname" disabled/>
              </FormItem>
            </Col>
          </Row>
        </Card>

      </Col>
      <Col span="10">
        <Card :padding="8">
          <div slot="title">核销信息</div>
          <Row :gutter="6">
            <Col :span="8">
              <FormItem label="核销渠道" prop="channel">
                <Select v-model="form.channel">
                  <Option value="online" label="线上余额"/>
                  <Option value="offline" label="线下交易"/>
                </Select>
              </FormItem>
            </Col>
            <Col :span="16">
              <FormItem label="优选合同抬头" prop="taxTitle">
                <Select v-model="form.taxTitle">
                  <Option v-for="(item, key) in params.taxTitle" :key="'taxTitle' + key"
                          :value="item.id" :label="item.title"/>
                </Select>
              </FormItem>
            </Col>
            <div style="height: 2px; border-top: 1px solid #cccccc; width: 100%;"></div>
            <Col :span="8">
              <FormItem label="核销金额与币种">
                <Input v-model="params.collect.amount" disabled>
                  <span slot="append">{{ params.collect.currency }}</span>
                </Input>
              </FormItem>
            </Col>
            <Col :span="16">
              <FormItem label="银行名称" prop="bank">
                <Select v-model="form.bank" filterable clearable :disabled="form.channel === 'online'">
                  <Option v-for="(item, key) in params.banks" :key="'bank' + key"
                          :value="item.id" :label="item.title"/>
                </Select>
              </FormItem>
            </Col>
            <div style="height: 2px; border-top: 1px solid #cccccc; width: 100%;"></div>
            <Col :span="8">
              <FormItem label="是否开票">
                <Select v-model="form.invoice">
                  <Option value="YES" label="是"/>
                  <Option value="NO" label="否"/>
                </Select>
              </FormItem>
            </Col>
            <Col :span="16">
              <FormItem label="银行交易流水" prop="bankRecordId">
                <Input v-model="form.bankRecordId" placeholder="请输入银行交易流水号码"
                       :disabled="form.channel === 'online'"/>
              </FormItem>
            </Col>
            <div style="height: 2px; border-top: 1px solid #cccccc; width: 100%;"></div>
            <Col :span="12">
              <FormItem label="银行流水交易时间" prop="chargeTime">
                <DatePicker type="datetime" :options="dateOption" :disabled="params.chanenl === 'online'" v-model="form.chargeTime" placeholder="请选择银行流水交易时间" style="width: 240px" />
              </FormItem>
            </Col>
            <Col :span="12">
              <FormItem label="备注信息">
                <Input type="textarea" :rows="1" v-model="form.remarks" placeholder="请输入核销备注信息"></Input>
              </FormItem>
            </Col>
            <div style="height: 28px; border-top: 1px solid #cccccc; width: 100%;"></div>
            <Col :span="24">
              <Button type="primary" @click="startCharge">开始核销</Button>
            </Col>
          </Row>
        </Card>
      </Col>
      <Col span="7">
        <!-- 显示单号 -->
        <Card :padding="8">
          <span slot="title">订单信息</span>
          <Table border stripe :height="430" highlight-row :columns="displayCols" :data="params.shipments"></Table>
        </Card>
      </Col>
    </Row>
  </Form>
</template>

<style scoped>

</style>
